import { render, staticRenderFns } from "./TotalBoardList.vue?vue&type=template&id=91ea3cde&scoped=true"
import script from "./TotalBoardList.ts?vue&type=script&lang=ts&external"
export * from "./TotalBoardList.ts?vue&type=script&lang=ts&external"
import style0 from "./TotalBoardList.vue?vue&type=style&index=0&id=91ea3cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ea3cde",
  null
  
)

export default component.exports